import React from 'react';
import clsx from 'clsx';
import useStyles from '../../../Playoff.styles';
import FinalCard from './FinalCard';
import EmptyCard from '../../../components/Empty';
import ModifiedPlayoffRound from '../../../../../../../../models/pages/tournament/playoff/ModifiedPlayoffRound';
import RoundResult from '../../../../../../../../models/pages/tournament/playoff/RoundResult';
import useTranslation from '../../../../../../../../components/localization/customHooks/Translation';

const defaultProps = {
  round: null,
};

function FirstPlaceRound(props: {
  round?: ModifiedPlayoffRound | null;
  setParticipant: React.Dispatch<React.SetStateAction<RoundResult>>;
  winnerId: number | null | undefined;
  isEditMode: boolean;
}) {
  const classes = useStyles();
  const l10n = useTranslation();
  const { round, setParticipant, winnerId, isEditMode } = props;
  return (
    <div className={clsx(classes.flexColumn, classes.innerFinal)}>
      <div className={classes.subHeader}>{l10n.components.playoffSchedule.FIRST_PLACE}</div>
      <div className={classes.flexRow}>
        <svg className={classes.finalsLine}>
          <line x1="0" y1="0" x2="165" y2="50" className={classes.line} />
        </svg>
        {round ? (
          <FinalCard
            firstPlaceRound
            player={round.firstParticipant}
            setParticipant={setParticipant}
            winnerId={winnerId}
            isEditMode={isEditMode}
          />
        ) : (
          <EmptyCard isFinal />
        )}
      </div>
      <div className={classes.flexRow}>
        <svg className={clsx(classes.crossedLines, classes.finalsLine_2)}>
          <line x1="0" y1="25" x2="145" y2="280" className={classes.line} />
        </svg>
        {round ? (
          <FinalCard
            firstPlaceRound
            player={round?.secondParticipant}
            setParticipant={setParticipant}
            winnerId={winnerId}
            isEditMode={isEditMode}
          />
        ) : (
          <EmptyCard isFinal />
        )}
      </div>
    </div>
  );
}

FirstPlaceRound.defaultProps = defaultProps;

export default FirstPlaceRound;
